<template>
  <div class="dok-kartica">

    <!-- Podaci idu u dva stupca, da kartica ne bude visoka. Duga polja
         (tip dokumenta, rok s razdobljem, veza) zauzimaju cijelu sirinu. -->
    <div class="mreza">
      <div class="par puna" v-if="bussYr >= 2026 && $store.state.documentActiv === 'InvoiceSales' && document.TipDokumenta">
        <span class="k">Tip</span>
        <span class="v">{{document.TipDokumenta}}</span>
      </div>
      <div class="par">
        <span class="k">{{langC.Number}}</span>
        <span class="v jako cijelo">{{document.documentId}}</span>
      </div>
      <div class="par">
        <span class="k">Datum</span>
        <span class="v cijelo">{{locdocumentDate}} <span v-if="exportDoc" class="oznaka-ino">{{exportDoc}}</span></span>
      </div>
      <div class="par puna" v-if="$store.state.documentActiv === 'InvoiceSales'">
        <span class="k">{{lang.DeadLine}}</span>
        <span class="v">{{datesInvoice}}</span>
      </div>
      <div class="par">
        <span class="k">{{lang.User}}</span>
        <span class="v">{{document.First}} {{document.Last}}</span>
      </div>
      <div class="par" v-if="connTxt">
        <span class="k">
          <span v-if="this.$store.state.language == 'EN'">Conn.</span>
          <span v-if="this.$store.state.language == 'HR'">Veza</span>
        </span>
        <span class="v jako">{{connTxt}}</span>
      </div>
    </div>

    <div class="oznake" v-if="bussYr >= 2026 && $store.state.documentActiv === 'InvoiceSales' && document.eRacunPoslovniProces">
      <span v-if="document.eRacunPoslovniProcesSifra === 'P9' || document.eRacunPoslovniProcesSifra === 'P10'" class="znak znak-crveni">
        {{document.eRacunPoslovniProces}}
      </span>
      <span v-if="document.eRacunPoslovniProcesSifra !== 'P9' && document.eRacunPoslovniProcesSifra !== 'P10'" class="znak znak-zeleni">
        {{document.eRacunPoslovniProces}}
      </span>
      <div class="sitno mt-1" v-if="document.eRacunPoslovniProcesSifra === 'P9' || document.eRacunPoslovniProcesSifra === 'P10'">
        Referenca na: {{document.RefNaPrethodniRacun}}, {{document.RefNaPrethodniRacunDatum}}
      </div>
    </div>

    <v-btn text small color="primary" class="pl-0 mt-1" @click="biljeskeOtvorene = !biljeskeOtvorene">
      <v-icon small>{{ biljeskeOtvorene ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      {{ imaBiljeske ? 'Napomene i izmjene' : 'Zapis o izmjenama' }}
    </v-btn>

    <div v-if="biljeskeOtvorene" class="mt-1">
      <v-divider class="mb-2"></v-divider>
      <div class="par uspravno" v-if="document.documentDescription4">
        <span class="k">{{lang.Description4}}</span>
        <span class="v">{{document.documentDescription4}}</span>
      </div>
      <div class="par uspravno" v-if="document.documentDescription1">
        <span class="k">{{lang.Description1}}</span>
        <span class="v">{{document.documentDescription1}}</span>
      </div>
      <div class="par uspravno" v-if="document.documentDescription5">
        <span class="k">{{lang.Description5}}</span>
        <span class="v">{{document.documentDescription5}}</span>
      </div>
      <div class="par uspravno" v-if="document.documentDescription3">
        <span class="k">{{lang.Description3}}</span>
        <span class="v">{{document.documentDescription3}}</span>
      </div>
      <div class="par uspravno">
        <span class="k">{{langC.CreatedAt}}</span>
        <span class="v">{{locCreatedAt}}</span>
      </div>
      <div class="par uspravno">
        <span class="k">{{langC.UpdatedAt}}</span>
        <span class="v">{{locUpdatedAt}}</span>
      </div>
      <div class="par uspravno" v-if="document.email">
        <span class="k">E-pošta</span>
        <span class="v">{{document.email}}</span>
      </div>
    </div>

  </div>
</template>

<script>
import langEn from './documentDescEn'
import langHr from './documentDescHR'
import commEn from '@/language/commonEN'
import commHr from '@/language/commonHR'
import dayjs from 'dayjs'
import dateFormat from '@/snippets/dateFormat'

export default {
  data() {
    return {
      biljeskeOtvorene: false,
      document: {},
      locCreatedAt: '',
      locUpdatedAt: '',
      lang: {},
      langC: {},
      documentNameLoc: '',
      locdocumentDate: '',
      exportDoc: '',
      connTxt: '',
      bussYr: 2026,
      txtColor: 'green',
      datesInvoice: null,
    }
  },
  mounted() {
    if (this.$store.state.language === 'EN') {
      this.lang = langEn
      this.langC = commEn
      this.exportDoc = this.$store.state.documentActivHead.exportDoc ? ' EXPORT' : ''
    }
    if (this.$store.state.language === 'HR') {
      this.lang = langHr
      this.langC = commHr
      this.exportDoc = this.$store.state.documentActivHead.exportDoc ? ' IZVOZ' : '' 
    }
    if (this.$store.state.documentActivHead) {
      this.document = this.$store.state.documentActivHead
      this.documentNameLoc = this.$store.state.documentActivLoc
      this.bussYr = this.document && this.document.BusinessYear ? this.document.BusinessYear : 2026
     
      if (this.document.documentDate) {
          this.locdocumentDate = dayjs(this.document.documentDate).format('DD.MM.YYYY')
      }
      // "MM" su mjeseci, minute su "mm". S "HH:MM" je vrijeme uvijek pokazivalo
      // mjesec umjesto minuta - dokument s rujna je pisao 00:09 bez obzira u
      // koliko sati je nastao.
      this.locCreatedAt = dayjs(this.document.createdAt).format('DD.MM.YYYY HH:mm')
      this.locUpdatedAt = dayjs(this.document.updatedAt).format('DD.MM.YYYY HH:mm') + (this.document.LastUpdateBy ? ', ' + this.document.LastUpdateBy : '')
      this.connTxt =  (this.document.documentConnName ? this.document.documentConnName + ':' : '') + (this.document.documentConnId ? this.document.documentConnId + '/' : '') + (this.document.documentConnDate ? dayjs(this.document.documentConnDate).format('DD.MM.YYYY HH:mm') : '')

      // Rok placanja i razdoblje isporuke.
      //
      // Razdoblje ima smisla samo kad postoje OBA datuma. Prije se niz slagao
      // bez provjere, pa je kod racuna bez kraja razdoblja - a takvih je vecina -
      // ostajalo "13.10.2026, Period: 28.09.2026 -", s crticom u prazno.
      // Sam pocetak se ne pise: on je jednak datumu dokumenta, koji stoji redak
      // iznad, pa bi se samo ponovio.
      const rok = this.document.documentInvoiceEndDate
        ? dayjs(this.document.documentInvoiceEndDate).format('DD.MM.YYYY') : ''
      const razdobljeOd = this.document.documentInvoiceStartDate
        ? dayjs(this.document.documentInvoiceStartDate).format('DD.MM.YYYY') : ''
      const razdobljeDo = this.document.documentInvoiceEndPeriodDate
        ? dayjs(this.document.documentInvoiceEndPeriodDate).format('DD.MM.YYYY') : ''
      const razdoblje = razdobljeOd && razdobljeDo
        ? 'Period: ' + razdobljeOd + ' - ' + razdobljeDo
        : ''
      this.datesInvoice = [rok, razdoblje].filter(x => x).join(', ')

    }
  },
  computed: {
    // Gumb za napomene se pokazuje samo kad dokument doista ima neku napomenu.
    imaBiljeske () {
      const d = this.document
      return !!(d.documentDescription1 || d.documentDescription3 ||
        d.documentDescription4 || d.documentDescription5 || d.email)
    },
  },
  methods: {
    localDate(dateToFormat) {
      return dateFormat(dateToFormat)
    },
  } 
}
</script>

<style>
/* Najvise DVA stupca, a jedan kad kartica postane uza od ~340px.
   Mjeri se sirina SAME KARTICE, ne ekrana - ista kartica stoji i u trecini
   sirine i preko cijele. Trak je zato barem pola kartice ("100% - razmak"
   podijeljeno s dva), pa ih vise od dva ne stane; kad kartica padne ispod
   dvostrukih 160px, prevlada minimum i ostaje jedan stupac.
   Sam "auto-fit" s minimumom od 160px na sirokoj je kartici slagao cetiri
   stupca i sve u njima lomio. */
.dok-kartica .mreza {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(max(160px, (100% - 16px) / 2), 1fr));
  gap: 0 16px;
}
.dok-kartica .mreza .par.puna { grid-column: 1 / -1; }
.dok-kartica .par { display: flex; justify-content: space-between; gap: 10px; padding: 1px 0; }
.dok-kartica .par.uspravno { display: block; padding: 3px 0; }
.dok-kartica .par.uspravno .v { display: block; text-align: left; }
.dok-kartica .par .k { color: rgba(0,0,0,.6); font-size: 13px; white-space: nowrap; flex: 0 0 auto; }
/* Datum i broj se nikad ne smiju prelomiti - "28.09.2 026" nije datum. */
.dok-kartica .par .v.cijelo { white-space: nowrap; }
/* "anywhere" je lomio na bilo kojem znaku, pa je na uskom ekranu od imena
   ostajalo "Ml ad en M ad ari c", a od datuma "28.09.2 026". "break-word"
   lomi rijec tek kad sama ne stane u redak - dugi naziv bez razmaka
   (JavnaustanovaNACIONALNIPARK) se i dalje prelomi, a ime i datum ostaju cijeli. */
.dok-kartica .par .v { text-align: right; min-width: 0; overflow-wrap: break-word; }
.dok-kartica .par .v.jako { font-weight: 700; }
.dok-kartica .oznake { margin-top: 8px; }
.dok-kartica .znak { display: inline-block; border-radius: 11px; padding: 2px 10px; font-size: 12px; }
.dok-kartica .znak-zeleni { background: #e8f5e9; color: #2e7d32; }
.dok-kartica .znak-crveni { background: #ffebee; color: #c62828; }
.dok-kartica .oznaka-ino { font-weight: 700; color: #1565c0; margin-left: 6px; }
.dok-kartica .sitno { font-size: 12px; color: rgba(0,0,0,.6); }


</style>